<footer id="footer-footer" class="footer">
  <mat-divider id="footer-divider"></mat-divider>
  <div id="footer-inner" class="footer-inner">
    <div id="footer-copyright">&copy; {{test | date: 'yyyy'}}, Trip-arc</div>
    <app-version id="footer-app-version"></app-version>
  </div>
</footer>

